const getShiftsAPI = (day) => {
  if (day) {
    return `api/shifts?day=${day}`;
  }
  return 'api/shifts';
};

const getShiftDetailsAPI = (shiftId) => `api/shifts/${shiftId}`;

const createShiftAPI = () => 'api/shifts';

const updateShiftAPI = (shiftId) => `api/shifts/${shiftId}`;

const updateShiftSummaryAPI = (shiftId) => `api/shifts/${shiftId}/summary`;

const deleteShiftAPI = (shiftId) => `api/shifts/${shiftId}`;

const individualCommissionsCRUDAPI = (shiftId) => `api/shifts/${shiftId}/commissions/individual`;

const teamCommissionsCRUDAPI = (shiftId) => `api/shifts/${shiftId}/commissions/team`;

const perVehicleCommissionsCRUDAPI = (shiftId) => `api/shifts/${shiftId}/commissions/per-vehicle`;

const createTimeClockAPI = (shiftId) => `api/shifts/${shiftId}/timeclocks`;

const updateTimeClockAPI = (shiftId, timeClockId) => `api/shifts/${shiftId}/timeclocks/${timeClockId}`;

const deleteTimeClockAPI = (shiftId, timeClockId) => `api/shifts/${shiftId}/timeclocks/${timeClockId}`;

export const shiftsEndpoints = {
  getShiftsAPI,
  getShiftDetailsAPI,
  createShiftAPI,
  updateShiftAPI,
  updateShiftSummaryAPI,
  deleteShiftAPI,
  individualCommissionsCRUDAPI,
  teamCommissionsCRUDAPI,
  perVehicleCommissionsCRUDAPI,
  createTimeClockAPI,
  updateTimeClockAPI,
  deleteTimeClockAPI,
};
